/**
 * ========================================
 * CONFIGURATION: API & SOCKET CONNECTION
 * ========================================
 *
 * This file defines the URLs used by the frontend
 * to communicate with the backend (API + WebSockets).
 *
 * IMPORTANT:
 * You must switch between LOCAL and DEPLOYMENT
 * depending on where the app is running.
 *
 * ----------------------------------------
 * ✅ PRODUCTION (DEPLOYED SERVER)
 * ----------------------------------------
 * Use these values when the app is hosted online.
 * This connects the frontend to the live backend.
 *
 * ALSO make sure:
 * - the backend .env file uses the same server
 */

export const SERVER_URL = "https://server.ksb-it.ch/api/";
export const SOCKET_URL = "https://server.ksb-it.ch";

/**
 * ----------------------------------------
 * ✅ LOCAL DEVELOPMENT
 * ----------------------------------------
 * Uncomment these when running the app locally.
 * This connects the frontend to your local backend.
 *
 * Example:
 * - frontend runs on: http://localhost:3000
 * - backend runs on:  http://localhost:3006
 *
 * ALSO make sure:
 * - your backend is running locally
 * - your backend .env matches the same port
 */

// export const SERVER_URL = "http://localhost:3006/api/";
// export const SOCKET_URL = "http://localhost:3006";
